import type { ReactNode } from 'react';

interface TestCardProps {
  title: string;
  description: string;
  children: ReactNode;
}

export function TestCard({ title, description, children }: TestCardProps) {
  return (
    <div className="border border-border rounded-[18px] bg-white/[.02] p-4">
      <h2 className="text-[22px] font-black tracking-tight mb-1.5">{title}</h2>
      <p className="text-sm text-muted leading-snug mb-3.5">{description}</p>
      {children}
    </div>
  );
}
